import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { OwnStorageFacility } from 'noddi-types';
import { NoddiBasicCard, NoddiButton, NoddiDialog } from 'noddi-ui-web';

type Props = {
  facilities: OwnStorageFacility[];
  /** Return to the pickup step after clearing the rejected address. */
  onChangePickup: () => void;
  onDismiss: () => void;
};

/**
 * Shown when booking creation was refused because the pickup address is one of our own storage facilities
 * (backend `wheel_pickup_address_is_own_storage_facility`). Wheels stored with us come along with the booking, so the
 * customer is sent back to pick another option instead of a pickup from our own hall.
 */
export const OwnStorageFacilityPickupDialog = ({ facilities, onChangePickup, onDismiss }: Props) => (
  <NoddiDialog
    open
    onClose={onDismiss}
    title={t`Your wheels are already with us`}
    description={t`The address you entered is our own storage facility. Wheels stored with us come along with the booking, so no pickup is needed. Choose another option for where we pick up your wheels.`}
    footer={
      <div className='flex items-center justify-end gap-2'>
        <NoddiButton variant='outline' onClick={onDismiss}>
          <Trans>Close</Trans>
        </NoddiButton>
        <NoddiButton variant='success' onClick={onChangePickup}>
          <Trans>Change pickup</Trans>
        </NoddiButton>
      </div>
    }
  >
    <div className='flex flex-col gap-2'>
      {facilities.map((facility) => (
        <NoddiBasicCard key={facility.storageFacilityId} className='flex flex-col gap-1'>
          <span className='text-lg font-medium'>{facility.name}</span>
          <span>{facility.address}</span>
        </NoddiBasicCard>
      ))}
    </div>
  </NoddiDialog>
);
